import { render } from "./UppyInput.vue?vue&type=template&id=8c8a1b1a"
import script from "./UppyInput.vue?vue&type=script&lang=js"
export * from "./UppyInput.vue?vue&type=script&lang=js"

import "./UppyInput.vue?vue&type=style&index=0&id=8c8a1b1a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__